import React, { forwardRef } from 'react';
import { Select } from 'zarm';

import { BaseWidgetProps, OptionsProps } from '../../utils/type';
import { isObject } from '../../utils/tools';

export interface SelectProps extends BaseWidgetProps {
  value?: any;
  defaultValue?: any;
  placeholder?: string;
  options: OptionsProps;
  dataSource: OptionsProps;
  valueMember?: string;
  reset?:string[];
  paramType?: 'string' | 'object';
  readOnly?: boolean;
  readonly?: boolean;
  className?: string;
  validate?: {
    rules: any[];
  };
}

/**
 * 获取值，针对picker 银行分行
 * @param value
 * @param valueMember
 */
function getValue(value: any, valueMember: string) {
  if (value && isObject(value)) {
    const newValue: any[] = [];

    if (value.parents && Array.isArray(value.parents) && value.parents.length) {
      value.parents.forEach((item) => {
        if (item) {
          newValue.push(item[valueMember]);
        }
      });
    }

    newValue.push(value[valueMember]);

    return newValue;
  }

  return value;
}

// 获取列表文字
function getSelectLabel(value: any, list: OptionsProps = [], valueMember: string, ...others) {
  const len: number = list.length;
  let i: number = 0;
  let item: any = {};
  let isBreak: boolean = false;

  if (value) {
    value = getValue(value, valueMember);
  }

  for (; i < len; i += 1) {
    item = list[i];

    if (~value.indexOf(item[valueMember])) {
      isBreak = true;

      if (item.children) {
        return getSelectLabel(value, item.children, valueMember, item);
      }

      return [...others, item];
    }

    if (isBreak) {
      break;
    }
  }

  return [];
}

function USelect(props: SelectProps, ref: any) {
  const {
    prefixCls = 'crm-select',
    onChange,
    valueMember = 'value',
    readOnly,
    dataSource,
    defaultValue,
    value,
    paramType,
    ...rest
  } = props;
  const selectValue: any = {};

  if (defaultValue) {
    selectValue.defaultValue = getValue(defaultValue, valueMember);
  }

  if (value) {
    selectValue.value = getValue(value, valueMember);
  }

  // 只读
  if (readOnly) {
    const selected = getSelectLabel((value || defaultValue), dataSource, valueMember);

    return (
      <div className={`${prefixCls}-readOnly`}>
        {(selected && Array.isArray(selected) && selected.length) ? selected.map((item) => item.label).join('') : null}
      </div>
    );
  }

  function onOk(selected: any) {
    let values: any = '';

    if (paramType === 'object') {
      if (selected && Array.isArray(selected) && selected.length) {
        const len = selected.length;
        const parents: any[] = [];
        values = { ...selected[len - 1] };

        if (len > 1) {
          selected.forEach((item, key) => {
            if (key < len - 1) {
              item = { ...item };

              // delete item children
              if (item.children) {
                delete item.children;
              }

              parents.push(item);
            }
          });

          values.parents = parents;
        }
      }
    } else if (selected && Array.isArray(selected)) {
      values = selected.map((selecte) => selecte[valueMember]);

      // 值数组长度等于string[]，默认转换string。如：['1']转换'1'
      if (selected && Array.isArray(selected) && selected.length === 1) {
        [values] = values;
      }
    } else if (isObject(selected)) {
      values = selected[valueMember];
    }

    if (onChange) {
      onChange(values);
    }
  }

  return (
    <Select
      {...rest}
      {...selectValue}
      ref={ref}
      dataSource={dataSource}
      valueMember={valueMember}
      onOk={(e) => onOk(e)}
    />
  );
}

export default forwardRef(USelect);
